// extracted by mini-css-extract-plugin
export default {"footer":"yCGwUIXIpvj0HON4MbXr"};